import { AbstractPmsApiService } from "./abstract.service";
import { ZatcaApiSetting } from "../models";

/**
 * @class ZatcaApiSettingPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ZatcaApiSetting>}
 */
export class ZatcaApiSettingPmsApiService extends AbstractPmsApiService {
  /**
   * @type {string}
   * @protected
   */
  get urlPattern() {
    return "/properties/:propertyId/zatca";
  }

  /**
   * @param {Object.<string, *>} attributes
   * @returns {ZatcaApiSetting}
   * @protected
   */
  newModel(attributes, ...params) {
    return new ZatcaApiSetting(attributes);
  }

  /**
   * @param {Property} property
   * @returns {Promise.<ZatcaApiSetting>}
   */
  toggleStatus(property) {
    const url = this.url({ propertyId: property.id }) + '/toggle-status';
    return this.http
      .post(url, {}, {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }

  /**
   * @param {Property} property
   * @param {Object} data - { organization_identifier: string, environment: string }
   * @returns {Promise.<ZatcaApiSetting>}
   */
  generateCsr(property, data) {
    const url = this.url({ propertyId: property.id }) + '/generate-csr';
    return this.http
      .post(url, data, {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
  }

  /**
   * @param {Property} property
   * @param {Object} data - { otp: string }
   * @returns {Promise.<ZatcaApiSetting>}
   */
  requestCsid(property, data) {
    const url = this.url({ propertyId: property.id }) + '/request-csid';
    return this.http
      .post(url, data, {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }

  /**
   * @param {Property} property
   * @returns {Promise.<ZatcaApiSetting>}
   */
  getCredentials(property) {
    const url = this.url({ propertyId: property.id }) + '/credentials';
    return this.http
      .get(url, {
        headers: this.authHeaders,
      })
      .then(this.getModeler())
      .catch(this.getErrorHandler());
  }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/zatca-api-setting.service.js